import React from 'react'

type Props = {
    navigationAlign : 'left' | 'right'
    tabs            : {
        label           : string
        component       : any
    }[]
    selectedIndex?  : number
}

export default class FormTabsSelector extends React.Component<Props, any> {

    static defaultProps = {
        navigationAlign: 'right'
    }

    constructor(props: Props) {
        super(props);

        this.state = {
            selectedIndex: 0
        }
    }

    onSelect = (index: number) => {
        this.setState({
            selectedIndex: index
        })
    }

    render() {
        const {component} = this.props.tabs[this.state.selectedIndex]

        const lastTabSelected = this.props.navigationAlign === 'right' && this.state.selectedIndex === this.props.tabs.length - 1

        return (
            <div className="form-tabs-selector">
                <div className="ui5-tabs on-white">
                    <div className={Classes("navigation", "with-tab-content", this.props.navigationAlign)}>
                        {_.map(this.props.tabs, (tab,key)=>
                            <div key={key} className={Classes("item", {selected: key === this.state.selectedIndex})} onClick={()=>{this.onSelect(key)}}>
                                <div className="label">{tab.label}</div>
                            </div>
                        )}
                    </div>
                    <div className={Classes("tab-content", {"last-tab-selected": lastTabSelected})}>
                        {component}
                    </div>
                </div>
            </div>
        )
    }
}